import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StudentAttendanceAbsencesTab } from '@features/student-page/components/StudentAttendanceAbsencesTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/students/$studentNo/attendance/absences')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Absences',
        },
    },
})

function RouteComponent() {
    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title="Failed to load student absences">
            <Suspense fallback={<LoadingIndicator resource="absences" />}>
                <StudentAttendanceAbsencesTab studentNo={studentNo} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
